import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum AddIconVariant {
  DEFAULT = 'default',
  ADD2 = 'add2',
  ADD3 = 'add3',
  NO_BORDER = 'NO_BORDER',
}

interface IAddIconProps extends IConDefaultType {
  variant?: AddIconVariant;
}

function AddIcon({ color, className, size = 24, rotate, flip, variant = AddIconVariant.DEFAULT }: IAddIconProps) {
  const fill = color || EColorMap.gray_1;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === AddIconVariant.DEFAULT && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.4 9.99982C16.4 6.46519 13.5346 3.59982 10 3.59982C6.46538 3.59982 3.6 6.46519 3.6 9.99982C3.6 13.5344 6.46538 16.3998 10 16.3998C13.5346 16.3998 16.4 13.5344 16.4 9.99982ZM18 9.99982C18 5.58154 14.4183 1.99982 10 1.99982C5.58172 1.99982 2 5.58154 2 9.99982C2 14.4181 5.58172 17.9998 10 17.9998C14.4183 17.9998 18 14.4181 18 9.99982Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.8003 7.00099C10.8003 6.55916 10.4421 6.20099 10.0003 6.20099C9.55847 6.20099 9.20029 6.55916 9.20029 7.00099L9.20029 9.20099H7.0002C6.55837 9.20099 6.2002 9.55916 6.2002 10.001C6.2002 10.4428 6.55837 10.801 7.0002 10.801H9.20029L9.20029 13.0009C9.20029 13.4427 9.55846 13.8009 10.0003 13.8009C10.4421 13.8009 10.8003 13.4427 10.8003 13.0009V10.801H13.0001C13.4419 10.801 13.8001 10.4428 13.8001 10.001C13.8001 9.55916 13.4419 9.20099 13.0001 9.20099H10.8003V7.00099Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === AddIconVariant.ADD2 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM11.4 7.8C11.4 7.46863 11.6686 7.2 12 7.2C12.3314 7.2 12.6 7.46863 12.6 7.8V11.4H16.2C16.5314 11.4 16.8 11.6686 16.8 12C16.8 12.3314 16.5314 12.6 16.2 12.6H12.6V16.2C12.6 16.5314 12.3314 16.8 12 16.8C11.6686 16.8 11.4 16.5314 11.4 16.2V12.6H7.8C7.46863 12.6 7.2 12.3314 7.2 12C7.2 11.6686 7.46863 11.4 7.8 11.4H11.4V7.8Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === AddIconVariant.ADD3 && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M11 17H13V13H17V11H13V7H11V11H7V13H11V17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === AddIconVariant.NO_BORDER && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 6C11.4477 6 11 6.44772 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7C13 6.44772 12.5523 6 12 6Z"
            fill={fill}
          />
        </svg>
      )}
    </i>
  );
}

export default AddIcon;
